import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6ea4c77d from 'nuxt_plugin_plugin_6ea4c77d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_0470bd7c from 'nuxt_plugin_bootstrapvue_0470bd7c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_templatesplugin456310cc_2e21ce06 from 'nuxt_plugin_templatesplugin456310cc_2e21ce06' // Source: ./templates.plugin.456310cc.js (mode: 'client')
import nuxt_plugin_workbox_72707b22 from 'nuxt_plugin_workbox_72707b22' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_1229aafc from 'nuxt_plugin_metaplugin_1229aafc' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_08da6014 from 'nuxt_plugin_iconplugin_08da6014' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_03008613 from 'nuxt_plugin_axios_03008613' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_vuexpersistclient_275f21a4 from 'nuxt_plugin_vuexpersistclient_275f21a4' // Source: ../plugins/vuex-persist-client.js (mode: 'client')
import nuxt_plugin_vuexpersistssr_b640b5fa from 'nuxt_plugin_vuexpersistssr_b640b5fa' // Source: ../plugins/vuex-persist-ssr.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_googlemaps_ab35f716 from 'nuxt_plugin_googlemaps_ab35f716' // Source: ../plugins/google-maps (mode: 'all')
import nuxt_plugin_bootstrapvue_7a18ce66 from 'nuxt_plugin_bootstrapvue_7a18ce66' // Source: ../plugins/bootstrap-vue.js (mode: 'all')
import nuxt_plugin_servertime_707e4c76 from 'nuxt_plugin_servertime_707e4c76' // Source: ../plugins/server-time.js (mode: 'client')
import nuxt_plugin_globalPayments_a56b615e from 'nuxt_plugin_globalPayments_a56b615e' // Source: ../plugins/globalPayments.js (mode: 'all')
import nuxt_plugin_globals_57393abd from 'nuxt_plugin_globals_57393abd' // Source: ../plugins/globals.js (mode: 'all')
import nuxt_plugin_googleAnalytics_728a9100 from 'nuxt_plugin_googleAnalytics_728a9100' // Source: ../plugins/googleAnalytics.js (mode: 'client')
import nuxt_plugin_hotjar_6900f5d3 from 'nuxt_plugin_hotjar_6900f5d3' // Source: ../plugins/hotjar.js (mode: 'client')
import nuxt_plugin_echo_6dbc5b20 from 'nuxt_plugin_echo_6dbc5b20' // Source: ./echo.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"web","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"hid":"charset","charset":"utf-8"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"TopsPizza"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"TopsPizza"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"TopsPizza"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Work+Sans"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,400;0,700;0,900;1,100&display=swap"},{"hid":"shortcut-icon","rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.ee09a2.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.ee09a2.png","sizes":"512x512"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.cb5e8a64.json","hid":"manifest"}],"style":[],"script":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6ea4c77d === 'function') {
    await nuxt_plugin_plugin_6ea4c77d(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_0470bd7c === 'function') {
    await nuxt_plugin_bootstrapvue_0470bd7c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin456310cc_2e21ce06 === 'function') {
    await nuxt_plugin_templatesplugin456310cc_2e21ce06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_72707b22 === 'function') {
    await nuxt_plugin_workbox_72707b22(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_1229aafc === 'function') {
    await nuxt_plugin_metaplugin_1229aafc(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_08da6014 === 'function') {
    await nuxt_plugin_iconplugin_08da6014(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_03008613 === 'function') {
    await nuxt_plugin_axios_03008613(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistclient_275f21a4 === 'function') {
    await nuxt_plugin_vuexpersistclient_275f21a4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexpersistssr_b640b5fa === 'function') {
    await nuxt_plugin_vuexpersistssr_b640b5fa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_ab35f716 === 'function') {
    await nuxt_plugin_googlemaps_ab35f716(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_7a18ce66 === 'function') {
    await nuxt_plugin_bootstrapvue_7a18ce66(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_servertime_707e4c76 === 'function') {
    await nuxt_plugin_servertime_707e4c76(app.context, inject)
  }

  if (typeof nuxt_plugin_globalPayments_a56b615e === 'function') {
    await nuxt_plugin_globalPayments_a56b615e(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_57393abd === 'function') {
    await nuxt_plugin_globals_57393abd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleAnalytics_728a9100 === 'function') {
    await nuxt_plugin_googleAnalytics_728a9100(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_6900f5d3 === 'function') {
    await nuxt_plugin_hotjar_6900f5d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echo_6dbc5b20 === 'function') {
    await nuxt_plugin_echo_6dbc5b20(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
